import { Download } from '@mui/icons-material'
import React, { FC } from 'react'
import IconButton from '@mui/material/IconButton'

interface UploadButtonProps {
  onUpload: () => void
}

export const DownloadFileButton: FC<UploadButtonProps> = ({ onUpload }) => {
  return (
    <IconButton onClick={onUpload} sx={{ color: 'grey', position: 'relative', top: '2px' }}>
      <Download />
    </IconButton>
  )
}
